import { FormGroup, Input } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent } from 'views/components/SharedModal'

type Props = {
  onClose: () => void
  onSuccess: (createdId) => void
}

export const AddCarOwnerModal: FC<Props> = ({ onClose, onSuccess }) => {
  const { t } = useTranslation(['rates'])

  const { formHandler, formProgress } = useAFormHandler()

  const formik = useFormik<{ name?: string }>({
    initialValues: {
      name: undefined,
    },
    onSubmit: formHandler(
      async () => {
        return await apiClient.post(endpoints.LogisticsKR.railCarOwners(), formik.values)
      },
      {
        onSuccess: async (carOwner?) => {
          carOwner?.id && onSuccess(carOwner.id)
          onClose()
        },
      },
    ),
  })

  return (
    <ResponsiveModal
      id="addCarOwner"
      onClose={onClose}
      title={t('addCarOwner')}
      onConfirm={formik.submitForm}
      progress={formProgress}
      size="medium"
    >
      <SharedModalContent>
        <FormGroup label={t('common:name')} error={formik.errors.name}>
          <Input {...formik.getFieldProps('name')} invalid={!!formik.errors.name} />
        </FormGroup>
      </SharedModalContent>
    </ResponsiveModal>
  )
}
